function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11969_222136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9583 3.99414C34.6124 4.03063 32.3176 4.6855 30.3057 5.89262C28.2938 7.09974 26.6361 8.81637 25.5 10.8691C24.3638 8.81637 22.7061 7.09974 20.6942 5.89262C18.6823 4.6855 16.3876 4.03063 14.0416 3.99414C10.3019 4.15662 6.77851 5.79259 4.24117 8.54463C1.70383 11.2967 0.358807 14.9411 0.499954 18.6816C0.499954 28.1546 10.4708 38.5004 18.8333 45.515C20.7004 47.084 23.0611 47.9442 25.5 47.9442C27.9388 47.9442 30.2995 47.084 32.1666 45.515C40.5291 38.5004 50.5 28.1546 50.5 18.6816C50.6411 14.9411 49.2961 11.2967 46.7587 8.54463C44.2214 5.79259 40.698 4.15662 36.9583 3.99414Z",
    fill: "url(#paint0_linear_11969_222136)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11969_222136",
    x1: 25.5,
    y1: 3.99414,
    x2: 25.5,
    y2: 47.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11969_222136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  }))));
};
export default SvgIconHeart;